import { Close } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';
import { IconButton, styled } from '@material-ui/core';

interface Props {
  onClose?: () => void;
}

const ModalCloseButton = ({ onClose }: Props) => {
  return (
    <CloseButton onClick={onClose} data-testid="modal-closeButton">
      <Close size={24} color={colorSet.gray900} />
    </CloseButton>
  );
};

export default ModalCloseButton;

const CloseButton = styled(IconButton)({
  position: 'absolute',
  padding: 6,
  top: 18,
  right: 18,
  zIndex: 1
});
